module.exports = __webpack_public_path__ + "static/media/notification.b9e7980e.mp3";